import React from "react";

import InfoTooltip from "components/InfoTooltip";

export const PAYROLL_IN_ERROR_STATE = "PayrollInError";

const ERROR_REASON_LABELS: Record<string, string> = {
  EmployerFrozen: "Employer frozen",
  ContributionLimitExceeded: "Contribution limit exceeded",
  AchInitiationFailed: "ACH initiation failed",
  AchTransferFailed: "ACH transfer failed",
  FundsTransferFailed: "Funds transfer failed",
  InsufficientServiceAccountFunds: "Insufficient service account funds",
  LineItemsNotAggregated: "Line items not aggregated",
  PayrollRunFailed: "Payroll run failed",
};

interface PayrollErrorReasonProps {
  state?: string | null;
  errorReason?: string | null;
  errorDetail?: string | null;
}

const PayrollErrorReason = ({
  state,
  errorReason,
  errorDetail,
}: PayrollErrorReasonProps) => {
  if (state !== PAYROLL_IN_ERROR_STATE) {
    return null;
  }
  if (!errorReason) {
    return <>Unknown</>;
  }

  return (
    <>
      {ERROR_REASON_LABELS[errorReason] ?? errorReason}{" "}
      {errorDetail && <InfoTooltip tooltipBody={errorDetail} />}
    </>
  );
};

export default PayrollErrorReason;
